/* The page's skeleton: the picker column on the left, the chart column on the right. Built
   once and handed around as references, so no panel looks another one up by id. */

import { el } from "../../ui/dom";
import { createGrid } from "../../ui/grid";
import { createTooltip } from "../../ui/tooltip";

export const tooltip = createTooltip();
export const grid = createGrid(tooltip);

const picker = el("div", { class: "picker" });
/* Sits in the left column, in place of the selectors: picking a spot and describing a new
   one are the same job, never done at once. */
const creator = el("section", { class: "creator", hidden: true });
/* The write tools, at the foot of the left column: the picker above says which chart, these
   say what to do with it. They are the page's own buttons, not the bar's, and they sit where
   the hand already is. */
const tools = el("div", { class: "tools" });

const missing = el("p", { class: "warn offer", hidden: true });
const legend = el("div", { class: "legend" });
const bar = el("div", { class: "bar" });

const spotTitle = el("h2", { dataset: { testid: "spot-title" } }, "Spot");
const notationBody = el("div");
const notation = el("section", { class: "notation" }, el("header", {}, spotTitle), notationBody);

const store = el("div", { class: "store" });
const approx = el("p", { class: "approx" });

const chart = el(
  "div",
  { class: "chart" },
  missing,
  grid.root,
  legend,
  bar,
  notation,
  store,
  approx,
);

export const dom = {
  page: el(
    "div",
    { class: "page" },
    el("aside", { class: "controls" }, picker, creator, tools),
    chart,
  ),
  picker,
  creator,
  tools,
  chart,
  missing,
  legend,
  bar,
  notation,
  spotTitle,
  notationBody,
  store,
  approx,
} as const;
